import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';

import teamImg from '../../assets/img/team/details-1-1.jpg';

const TeamDetailsMain = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', formRef.current, {
        publicKey: 'YOUR_PUBLIC_KEY',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        }
      );
  };

  return (
    <main>
      <Breadcrumb title="Team Details" subTittle="Team" />

      <div className="it-team-details-area pt-120 pb-120">
        <div className="container">
          <div className="it-team-details-top mb-115">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="it-team-details-left">
                  <div className="it-team-details-thumb">
                    <img src={teamImg} alt="" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="it-team-details-right">
                  <div className="it-team-details-auhtor-info">
                    <h5 className="it-team-details-auhtor-title">
                      Dr. Pauline W. Hamilton
                    </h5>
                    <span>Physiotherapist</span>
                  </div>
                  <div className="it-team-details-text">
                    <p className="mb-25">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Sed risus ultricies tristique nulla aliquet enim.
                      Quis commodo odio aenean sed adipiscing diam. Ornare
                      lectus sit amet est placerat in egestas. Proin libero nunc
                      consequat interdum varius sit amet mattis vulputate.
                    </p>
                    <span>
                      Turpis in eu mi bibendum. Volutpat odio facilisis mauris
                      sit. Vitae sapien pellentesque habitant morbi tristique.
                      Sed risus pretium quam vulputate dignissim suspendisse in
                      est.
                    </span>
                  </div>
                  <div className="it-shop-details__social mt-30">
                    <a href="#">
                      <i className="flaticon-facebook-app-symbol"></i>
                    </a>
                    <a href="#">
                      <i className="flaticon-twitter-1"></i>
                    </a>
                    <a href="#">
                      <i className="flaticon-pinterest"></i>
                    </a>
                    <a href="#">
                      <i className="flaticon-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="it-team-details-text mb-35">
                <h5 className="it-team-details-title mb-10">Introduction</h5>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="it-team-details-list list-style-1">
                  <h5 className="it-team-details-title mb-25">Specialties</h5>
                  <ul>
                    <li>
                      <i>Cardiology</i> D.N.Sc.
                    </li>
                    <li>
                      <i>Family Medicine </i>D.N.Sc. – M.B.B.S,Ph.D
                    </li>
                    <li>
                      <i>Oncology</i> M.B.B.S,Ph.D
                    </li>
                    <li>
                      <i>Dermatology</i> M.B.B.S,Ph.D
                    </li>
                    <li>
                      <i>Obstetrics & Gynecology</i> Ph.D
                    </li>
                    <li>
                      <i>Orthopedic Surgery</i> M.B.B.S,Ph.D
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="it-team-details-list list-style-2">
                  <h5 className="it-team-details-title mb-10">
                    Educational Info
                  </h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing <br />{' '}
                    elit, sed do eiusmod tempor incididunt{' '}
                  </p>
                  <ul>
                    <li>
                      <i>Medical College Of California</i> (Doctor of Medicine
                      2005)
                    </li>
                    <li>
                      <i>Center Of Medicine Anthology</i> (Medicine Doctorate
                      Aid 2010)
                    </li>
                    <li>
                      <i>Cambridge School Of Medicine</i> (MBBS Ph.D. 2014)
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="it-team-details-list list-style-3">
                  <h5 className="it-team-details-title mb-10">Specialties</h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt{' '}
                  </p>
                  <ul>
                    <li>
                      <i>European Society Of Cardiology</i>
                    </li>
                    <li>
                      <i>Fellow Royal Society Of Medicine</i>
                    </li>
                    <li>
                      <i>British Cardiovascular Society</i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-contact-area it-appointments-inner-style pb-120">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="it-contact-from-wrap text-center z-index">
                <h3 className="it-section-title pb-50">Make An Appointment</h3>
                <form ref={formRef} onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="first name:" />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="last name:" />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="email" placeholder="E-mail:" />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="email" placeholder="phone:" />
                      </div>
                    </div>
                    <div className="col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="subject:" />
                      </div>
                    </div>
                    <div className="col-12 mb-30">
                      <div className="it-contact-input-box">
                        <textarea placeholder="write a message...."></textarea>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="it-btn-theme d-flex justify-content-center align-items-center w-100"
                  >
                    <Button btnText="BOOK AN APPOINTMENT" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TeamDetailsMain;
